<template>
  <div class="layout-mood-colors-content" id="identidade-visual-mood-cores" data-search-anchor>
    <div class="title-layout-mood-colors-wrapper">
      <h1 class="layout-mood-colors-title-span">{{ layoutMoodColorsTitleSpan }}</h1>
      <h1 class="layout-mood-colors-title">{{ layoutMoodColorsTitle }}</h1>
    </div>
    <div
      class="layout-mood-colors-card-item"
      :style="{ backgroundImage: `url(${layoutMoodColorsImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LayoutsMoodColorsSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutMoodColorsTitleSpan(): string {
    return this.getElementTitle(12, 0)
  }

  get layoutMoodColorsTitle(): string {
    return this.getElementText(12, 0)
  }

  get layoutMoodColorsImageSrc(): string {
    return this.getElementMedia(12, 1)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-mood-colors-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-layout-mood-colors-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding: 6.25rem 0rem 2rem 0rem;
}

.layout-mood-colors-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #b3b3b3;
}

.layout-mood-colors-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-mood-colors-wrapper {
  padding: 3rem 3rem 0rem 3rem;
  position: relative;
  bottom: 5rem;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.layout-mood-colors-description {
  font-size: 25px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 374px;
}

.layout-mood-colors-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 444px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
